var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoalIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H38C43.5229 0 48 4.47715 48 10V38C48 43.5229 43.5228 48 38 48H10C4.47715 48 0 43.5228 0 38V10Z",
    fill: "#7F56D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 33V27M28 30H34M24 27H20C18.1362 27 17.2044 27 16.4693 27.3045C15.4892 27.7105 14.7105 28.4892 14.3045 29.4693C14 30.2044 14 31.1362 14 33M27.5 15.2908C28.9659 15.8841 30 17.3213 30 19C30 20.6787 28.9659 22.1159 27.5 22.7092M25.5 19C25.5 21.2091 23.7091 23 21.5 23C19.2909 23 17.5 21.2091 17.5 19C17.5 16.7909 19.2909 15 21.5 15C23.7091 15 25.5 16.7909 25.5 19Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalIcon1);
export default __webpack_public_path__ + "static/media/Goal_icon_1.f027010b93e0251f7ab7c077639c0211.svg";
export { ForwardRef as ReactComponent };